import { BaseEntity } from "../base/base-entity";
import { ProcedureEntity } from "@graffer-inc/cloud-gov-core";

export type ProcedureQuotaType = {
  readonly procedureId: string;
  readonly quota: number | undefined;
  readonly count: number;
  readonly createdAt: Date | undefined;
};

export class ProcedureQuotaEntity extends BaseEntity {
  public readonly procedureId: string;
  public readonly quota: number | undefined;
  public readonly count: number;
  public readonly createdAt: Date | undefined;

  constructor(base: ProcedureQuotaType) {
    super();
    this.procedureId = base.procedureId;
    this.quota = base.quota;
    this.count = base.count;
    this.createdAt = base.createdAt;
  }
  static newFrom(proc: ProcedureEntity): ProcedureQuotaEntity {
    return new ProcedureQuotaEntity({
      procedureId: proc.id,
      quota: undefined,
      count: 0,
      createdAt: undefined,
    });
  }

  static fromJSON(json: ProcedureQuotaType): ProcedureQuotaEntity {
    return new ProcedureQuotaEntity(json);
  }
}
